module.exports = __webpack_public_path__ + "img/t1-15.1b748ff7.png";